import React from "react";
import PropTypes from "prop-types";

const GrievanceFormPdfContent = () => {
  const lineHeight = 8;
  const bulletRadius = 4;
  const textIndent = "15px";
  const bulletStyle = {
    display: "inline-block",
    width: `${bulletRadius * 2}px`,
    height: `${bulletRadius * 2}px`,
    border: "1px solid black",
    borderRadius: "50%",
    marginRight: "15px",
    marginTop: "8px",
    verticalAlign: "middle",
  };

  const listItems = [
    "Any person(s) who believes that their rights have been violated or has a complaint or grievance can file a complaint pursuant to the procedures set forth below, on their behalf, or on the behalf of another person. All persons are encouraged to file a complaint and/or grievance. By filing a client grievance, the individual will not subject themselves to any form of adverse action, reprimand, retaliation, or otherwise negative treatment by Legacy Healing Center Margate, LLC. Clients will have immediate access to the grievance form located in their program information packet; a posting of the client grievance procedure will be in the first-floor lounge area with the levels of appeals, and in the Client handbook.",
    "To register a client grievance, the following steps will be followed:",
    "Clients, family members, and authorized guardians of a client's rights and responsibilities will be informed of their rights and responsibilities during the orientation, have knowledge of the grievance system, be assured that they can file a grievance at any time, and be knowledgeable of where the notice of grievance is located and where the forms are. Client Grievance Forms are in the reception area. The Grievance Form will be discussed with the Client within 1 day of the Grievance Form being given to the therapist.",
    "Clients are encouraged to discuss any problems with their primary therapist. The Client and therapist will try to find a resolution within 1 business day. The client will be given a response to the resolution in writing.",
    "If the Client is not satisfied with the results, the Client can appeal the decision and will then meet with the Clinical Director within 1 business day of the date of the request and appeal of the decision.",
    "The decision and resolution of the appeal regarding the grievance are then documented and submitted to the Client in writing.",
    "If the Client is still not satisfied, they can appeal the decision a third time and the Client will then meet with the CEO and/or the Governing Board within 1 business day. This is the final internal step in the grievance process and the decision is resolved or concluded by action of Legacy Healing Center Margate, LLC Governing Board.",
    "If a client does not feel a resolution has been reached, the client can file a complaint with the Southeast Region Department of Children & Family Services SAMH Program office.",
    "The grievance will be tracked and logged until resolved or concluded by actions of the provider's governing body by the Quality Assurance/Performance Improvement Coordinator. Analysis of trends to identify opportunities for improvement will be conducted and submitted to the Quality Assurance/Performance Improvement Committee quarterly meeting.",
    "Any allegations of physical or sexual abuse by a staff member will be brought to the immediate attention of the Clinical Director. The Client will be afforded the opportunity to contact DCF. The contact information for the Department of Children & Family Services will be posted in the BHT office at the community housing, the lounge area, reception area in the Center, and the client handbook.",
    "Notification to all parties of these rights will include affirmation of an organizational nonrelationship policy that protects a party's right to file a grievance or express their opinion and invokes applicability of state and federal protections.",
    "The Clinical Director and the CEO will take steps to ensure an appropriate investigation of each complaint to determine its validity. These rules contemplate informal, but thorough, investigations, affording all interested persons and their representatives, if any, an opportunity to submit evidence relevant to the complaint.",
    "If a client is dissatisfied at any point, the Client has the right to voice complaints, questions, or concerns about service, treatment, procedures, rights and policies by calling any one of the following agencies:",
    "Department of Children & Family Services (954)762-3700 The HIPAA Privacy Officer/Corporate Compliance Officer: (888) 576-8373. o The U.S. Department of Health and Human Services at for privacy or breach of confidentiality (HIPAA):",
    "The U.S. Department of Health and Human Services \n200 Independence Avenue, S.W.Washington\n, D.C. 20201 Toll-Free: 1-877-696-6775",
    "FARR (Florida Association of Recovery Residences) and file a grievance by going to:",
(
<div>
  <div style={{ fontWeight: "bold" }}>
    <a
      href="https://farronline.info/grievance"
      target="_blank"
      rel="noopener noreferrer"
      style={{ fontWeight: "bold", textDecoration: "none" }}
    >
      https://farronline.info/grievance
    </a>{" "}
    or
  </div>
  <div style={{ fontWeight: "bold", marginTop: "5px" }}>
    by contacting:<br />
    Florida Association of Recovery Residence<br />
    326 West Lantana Road Suite #1<br />
    Lantana, FL 33462<br />
    (561) 299-0405
  </div>
</div>



),

    "Any allegations of physical or sexual abuse by a counselor will immediately be brought to the attention of the Clinical Director. The Client will be afforded the opportunity to contact DCF.",
  ];

  return (
    <div
      style={{
        fontFamily: "Arial",
        padding: "20px",
        maxWidth: "800px",
        margin: "0 auto",
        fontSize: "20px",
        height: '2450px'
      }}
    >
      <div style={{ textAlign: "center" }}>
        <h2
          style={{
            display: "inline-block",
            fontSize: "26pt",
            fontFamily: "Elef Layla MF",
            marginBottom: "15px",
            borderBottom: "2px solid black",
            display: 'inline-block',
            paddingBottom: "0px",
           
          }}
        >
          CLIENT GRIEVANCE PROCEDURE:
        </h2>
      </div>

      <div style={{ marginBottom: "20px",marginTop:"15px" }}>
        {listItems.map((item, index) => {
          const isCenteredItem = index >= listItems.length - 4;

          if (isCenteredItem) {
            return (
              <div
                key={index}
                style={{
                  textAlign: "center",
                  marginBottom: "10px",
                  fontFamily: "Elef Layla MF",
                  lineHeight: "1.5",
                  // fontSize: "17px",
                }}
              >
               {typeof item === "string" ? (
  item.split("\n").map((line, i) => (
    <div
      style={index >= listItems.length - 2 ? { fontWeight: "bold" } : {}}
      key={i}
    >
      {line}
    </div>
  ))
) : (
  <div>{item}</div>
)}

              </div>
            );
          } else {
            return (
              <div
                key={index}
                style={{ marginBottom: "5px", fontFamily: "Elef Layla MF" }}
              >
                <div style={{ display: "flex" }}>
                  <div style={bulletStyle}></div>
                  <div style={{ flex: 1, lineHeight: "1.2" }}>{item}</div>
                </div>
              </div>
            );
          }
        })}
      </div>
    </div>
  );
};

GrievanceFormPdfContent.propTypes = {
  data: PropTypes.shape({
    clientName: PropTypes.string,
  })
};

export default GrievanceFormPdfContent;
